import { BadgeOwnerState } from "@mui/material";
import { EMPLOYEE_PRESENCE } from "./models/employeePresence.models";

const getPresenceColor = (
  presenceType: EMPLOYEE_PRESENCE
): BadgeOwnerState["color"] => {
  switch (presenceType) {
    case EMPLOYEE_PRESENCE.PRESENT:
      return "success";
    case EMPLOYEE_PRESENCE.ABSENT:
      return "error";
    default:
      return "primary";
  }
};

export default getPresenceColor;
